import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const menuItems = [
    { label: 'Dashboard', icon: 'fa-tachometer-alt', path: 'dashboard' },
    { label: 'Circuits', icon: 'fa-microchip', path: 'circuits' },
    { label: 'Jobs', icon: 'fa-tasks', path: 'jobs' },
    { label: 'Benchmarks', icon: 'fa-chart-line', path: 'benchmarks' },
    { label: 'Artifacts', icon: 'fa-archive', path: 'artifacts' },
    { label: 'Settings', icon: 'fa-cog', path: 'settings' },
  ];

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/');
  };

  // Custom styles for the logo in the sidebar
  const sidebarLogoStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center', // Center the logo
    padding: '1rem', // Add some padding
    marginBottom: '1rem', // Space below the logo
  };

  const smallIconTextStyle = {
    marginBottom: '0', // Override default margin from Logo component
  };

  const smallIconStyle = {
    borderRadius: '10px', // Smaller border radius
    padding: '0.5rem', // Smaller padding
    fontSize: '1rem', // Smaller icon size
  };

  const smallTitleStyle = {
    fontSize: '1.5rem', // Smaller font size for "nargklab"
    marginLeft: '0.5rem', // Adjust margin
  };

  return (
    <aside className="menu p-5 column is-narrow is-narrow-mobile is-fullheight is-flex is-flex-direction-column">
      <div>
        {/* Adjusted Logo component for sidebar */}
        <a href="/" style={sidebarLogoStyle}>
          <p className="title is-spaced" style={smallIconTextStyle}>
            <span className="icon-text">
              <span className="icon has-background-link has-text-white p-5" style={smallIconStyle}>
                <i className="fas fa-cube"></i>
              </span>
              <span className="ml-2 my-auto has-text-weight-extrabold" style={smallTitleStyle}>
                nargklab
              </span>
            </span>
          </p>
        </a>
        <ul className="menu-list">
          {menuItems.map((item, index) => {
            const isActive = location.pathname.split('/')[1] === item.path;
            return (
              <li key={`menu-item-${index}`}>
                <Link
                  to={'/' + item.path}
                  className={`is-flex py-3 is-align-items-center ${isActive ? 'is-active is-link' : ''}`}
                >
                  <span className="icon mr-3">
                    <i className={`fas ${item.icon}`}></i>
                  </span>
                  {item.label}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
      <div className="mt-auto">
        <button className="button is-fullwidth py-3 is-outlined is-black" onClick={handleLogout}>
          <span className="icon mr-3">
            <i className="fas fa-sign-out-alt"></i>
          </span>
          Log Out
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
